// Mapa de códigos de erro do Firebase Auth para mensagens amigáveis em PT-BR.
// O Firebase devolve mensagens cruas tipo "Firebase: Error (auth/invalid-credential)."
// que não fazem sentido pro usuário final. Usamos `err.code` quando disponível
// e caímos numa mensagem genérica quando não.
const FIREBASE_AUTH_MESSAGES = {
  // Credenciais inválidas — em SDKs modernos vem como invalid-credential
  // (login com email/senha errados); em versões antigas era wrong-password
  // ou user-not-found. Cobrimos os três pra retrocompatibilidade.
  'auth/invalid-credential':         'Email ou senha incorretos. Confira e tente novamente.',
  'auth/invalid-login-credentials':  'Email ou senha incorretos. Confira e tente novamente.',
  'auth/wrong-password':             'Senha incorreta. Tente novamente.',
  'auth/user-not-found':             'Não encontramos uma conta com esse email.',
  'auth/invalid-email':              'Email inválido. Confira se digitou corretamente.',
  'auth/user-disabled':              'Esta conta foi desativada. Entre em contato com o suporte.',
  'auth/too-many-requests':          'Muitas tentativas seguidas. Aguarde alguns minutos e tente novamente.',
  'auth/network-request-failed':     'Sem conexão. Verifique sua internet e tente de novo.',
  'auth/operation-not-allowed':      'Este método de login está desativado no momento.',
  'auth/email-already-in-use':       'Este email já está cadastrado. Tente entrar com ele.',
  'auth/weak-password':              'Senha muito curta. Use pelo menos 6 caracteres.',
  'auth/missing-password':           'Informe sua senha para continuar.',
  'auth/missing-email':              'Informe seu email para continuar.',
  'auth/requires-recent-login':      'Por segurança, faça login novamente para continuar.',
  'auth/popup-closed-by-user':       'Login cancelado. Tente de novo se quiser entrar.',
  'auth/account-exists-with-different-credential':
    'Já existe uma conta com este email usando outro método de login.',
  'auth/internal-error':             'Algo deu errado no nosso lado. Tente novamente em instantes.',
};

const DEFAULT_MESSAGE = 'Não conseguimos completar essa ação agora. Tente novamente em instantes.';

export function friendlyAuthError(err) {
  if (!err) return DEFAULT_MESSAGE;
  const code = String(err.code || '').toLowerCase();
  if (code && FIREBASE_AUTH_MESSAGES[code]) return FIREBASE_AUTH_MESSAGES[code];
  // Alguns erros chegam só com message — tenta extrair o code dela.
  const raw = String(err.message || '');
  const m = raw.match(/auth\/[a-z-]+/i);
  if (m) {
    const extracted = m[0].toLowerCase();
    if (FIREBASE_AUTH_MESSAGES[extracted]) return FIREBASE_AUTH_MESSAGES[extracted];
  }
  return DEFAULT_MESSAGE;
}
